export default __webpack_public_path__ + "static/media/calendar.ac5214a0.svg";